import api from '../../../../helpers/api';
import { setDisplayCharts } from '../../redux/dashboardActions';
import {
  updateChartsDataPrimary,
  updateRequestStatus,
} from './offersPrimary.actions';
// TODO
// MELHORAR A SEPARAÇÃO ENTRE O CONTROLE DE AÇÕES E O CONSUMO DE API
// DEVERÁ SER FEITO GRADATIVAMENTE

export const getEcoAndMapCharts = (payload) => {
  return (dispatch) => {
    if (payload.realtyType.id === 'ap') {
      dispatch([
        updateRequestStatus({ name: 'launchedUnits', value: 'LOADING' }),
        updateRequestStatus({
          name: 'launchedUnitsEcoMapPercentile',
          value: 'LOADING',
        }),
      ]);
      api
        .post(
          'developer/bloomberg/primary-market/launched-units-graph/eco-map',
          payload
        )
        .then((res) => {
          dispatch([
            updateChartsDataPrimary({
              name: 'eco_map',
              value: res.data.releases_sales_info,
            }),
            updateRequestStatus({ name: 'launchedUnits', value: 'LOADED' }),
            updateRequestStatus({
              name: 'launchedUnitsEcoMapPercentile',
              value: 'LOADED',
            }),
          ]);
        })
        .catch((err) => {
          dispatch([
            updateRequestStatus({ name: 'launchedUnits', value: 'FAILED' }),
            updateRequestStatus({
              name: 'launchedUnitsEcoMapPercentile',
              value: 'FAILED',
            }),
          ]);
          console.error(err);
        });
    } else {
      dispatch(
        updateRequestStatus({ name: 'launchedUnits', value: 'LOADING' })
      );
      api
        .post(
          'developer/bloomberg/primary-market/launched-units-graph/eco-map',
          payload
        )
        .then((res) => {
          dispatch([
            updateChartsDataPrimary({
              name: 'eco_map',
              value: res.data.releases_sales_info,
            }),
            updateRequestStatus({ name: 'launchedUnits', value: 'LOADED' }),
            setIsEcoAndMap(false),
          ]);
        })
        .catch((err) => {
          dispatch(
            updateRequestStatus({ name: 'launchedUnits', value: 'FAILED' })
          );
          console.error(err);
        });
    }
  };
};

export const getHarvestCharts = (payload) => {
  return (dispatch) => {
    dispatch(updateRequestStatus({ name: 'harvest', value: 'LOADING' }));
    api
      .post('developer/bloomberg/primary-market/sales/harvest', payload)
      .then((res) => {
        dispatch(
          updateChartsDataPrimary({ name: 'harvest', value: res.data.harvest })
        );
        dispatch(updateRequestStatus({ name: 'harvest', value: 'LOADED' }));
      })
      .catch((err) => {
        dispatch(updateRequestStatus({ name: 'harvest', value: 'FAILED' }));
        console.error(err);
      });
  };
};

export const getWeightedAverageChart = (payload) => {
  return (dispatch) => {
    dispatch(
      updateRequestStatus({ name: 'weightedAverage', value: 'LOADING' })
    );
    api
      .post(
        'developer/bloomberg/primary-market/weighted-average-chart',
        payload
      )
      .then((res) => {
        dispatch([
          updateChartsDataPrimary({ name: 'weightedAverage', value: res.data }),
          updateRequestStatus({ name: 'weightedAverage', value: 'LOADED' }),
        ]);
      })
      .catch((err) => {
        dispatch(
          updateRequestStatus({ name: 'weightedAverage', value: 'FAILED' })
        );
        console.error(err);
      });
  };
};

export const getInfoWindow = (coordinates) => {
  return api.get(`developer/bloomberg/mvp-primary-market/pin-info`, {
    params: {
      lat: coordinates?.lat,
      lon: coordinates?.long,
    },
  });
};

export const getWeightedAverageChartEcoMap = (payload) => {
  return (dispatch) => {
    dispatch(
      updateRequestStatus({ name: 'weightedAverageEcoMap', value: 'LOADING' })
    );
    api
      .post(
        'developer/bloomberg/primary-market/weighted-average-chart/eco-map',
        payload
      )
      .then((res) => {
        dispatch([
          updateChartsDataPrimary({
            name: 'weightedAverageEcoMap',
            value: res.data,
          }),
          updateRequestStatus({
            name: 'weightedAverageEcoMap',
            value: 'LOADED',
          }),
        ]);
      })
      .catch((err) => {
        dispatch(setDisplayCharts(null));
        dispatch(
          updateRequestStatus({
            name: 'weightedAverageEcoMap',
            value: 'FAILED',
          })
        );
        console.error(err);
      });
  };
};

export const getSalesCharts = (payload) => {
  return (dispatch) => {
    dispatch(updateRequestStatus({ name: 'sales', value: 'LOADING' }));
    api
      .post('developer/bloomberg/primary-market/sales', payload)
      .then((res) => {
        dispatch(updateChartsDataPrimary({ name: 'sales', value: res.data }));
        dispatch(updateRequestStatus({ name: 'sales', value: 'LOADED' }));
      })
      .catch((err) => {
        dispatch(updateRequestStatus({ name: 'sales', value: 'FAILED' }));
        console.error(err);
      });
  };
};

export const getReleasesSalesStockCharts = (payload) => {
  return (dispatch) => {
    dispatch(
      updateRequestStatus({ name: 'releasesSalesStock', value: 'LOADING' })
    );
    api
      .post('developer/bloomberg/primary-market/releases-sales-stock', payload)
      .then((res) => {
        dispatch(
          updateChartsDataPrimary({
            name: 'releasesSalesStock',
            value: res.data,
          })
        );
        dispatch(
          updateRequestStatus({ name: 'releasesSalesStock', value: 'LOADED' })
        );
      })
      .catch((err) => {
        dispatch(
          updateRequestStatus({ name: 'releasesSalesStock', value: 'FAILED' })
        );
        console.error(err);
      });
  };
};

export const getSalesChartsEcoMap = (payload) => {
  return (dispatch) => {
    dispatch(updateRequestStatus({ name: 'salesEcoMap', value: 'LOADING' }));
    api
      .post('developer/bloomberg/primary-market/sales/eco-map', payload)
      .then((res) => {
        dispatch(
          updateChartsDataPrimary({ name: 'salesEcoMap', value: res.data })
        );
        dispatch(updateRequestStatus({ name: 'salesEcoMap', value: 'LOADED' }));
      })
      .catch((err) => {
        dispatch(updateRequestStatus({ name: 'salesEcoMap', value: 'FAILED' }));
        console.error(err);
      });
  };
};

export const getReleasesSalesStockChartsEcoMap = (payload) => {
  return (dispatch) => {
    dispatch(
      updateRequestStatus({
        name: 'releasesSalesStockECOMAP',
        value: 'LOADING',
      })
    );
    api
      .post(
        'developer/bloomberg/primary-market/releases-sales-stock/eco-map',
        payload
      )
      .then((res) => {
        dispatch(
          updateChartsDataPrimary({
            name: 'releasesSalesStockECOMAP',
            value: res.data,
          })
        );
        dispatch(
          updateRequestStatus({
            name: 'releasesSalesStockECOMAP',
            value: 'LOADED',
          })
        );
      })
      .catch((err) => {
        dispatch(
          updateRequestStatus({
            name: 'releasesSalesStockECOMAP',
            value: 'FAILED',
          })
        );
        console.error(err);
      });
  };
};

export const getBuildingsCompaniesLists = () => {
  return api.get('developer/bloomberg/primary-market/list');
};

export const getBuildingDetails = (payload) => {
  return api.post(
    'developer/bloomberg/primary-market/detailed-enterprise-info',
    payload
  );
};

export const getBigNumbersPrimary = (payload) => {
  return api.post(
    'developer/bloomberg/mvp-primary-market/primary-market',
    payload
  );
};

export const getAvaliableFilters = (cityId) => {
  return api.get(
    `developer/bloomberg/mvp-primary-market/list/filters/${cityId}`
  );
};
